export const propertyID = 'UA-83152914-1';


// WEBPACK FOOTER //
// ./src/config/ga.js